<mat-dialog-content class="custom-scrollv2">
<div class="dialog-header">
  <div>
    {{title}}
  <span class="text-yellow ms-1" *ngIf="title=='Sales Fees' || title=='Sales COGS'">
   ({{(title==='Sales COGS' ? showToolTip.cogsPctOfRevenue : showToolTip.feesPctOfRevenue) | number: '1.0-0'}}% of revenue)
 </span>
  </div>
  <div class="dialog-header_closer" (click)="close()">
    <i class="fal fa-times"></i>
  </div>
</div> 
<mat-tree class="custom-mat-tree" [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle [ngClass]="{'node-tree-indent' : data.title == 'Profit' || data.title == 'COGS','gray-box border-0' : node.hasGrayClass }">
      <div class="d-flex align-items-center w-100">
        <span>{{ node.name }}</span>
        <div class="value-box ms-auto">
          <span class="pieces" *ngIf="node.pieces">{{node.pieces.toLocaleString("en")}}(PCS)</span>
          <span class="value ms-auto">{{ node.type == "currency" ? "$" + node.value.toLocaleString("en") : node.type == "percentage" ? node.value + "%" : node.value.toLocaleString("en") }}</span>
        </div>
      </div>
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" [ngClass]="{'gray-box border-0' : node.hasGrayClass }">
      <div class="mat-tree-node">
        <mat-icon class="mat-icon-rtl-mirror" mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
          {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
        </mat-icon>
        <div class="d-flex align-items-center w-100">
          <span>{{ node.name }}</span>
          <span class="text-yellow ms-2" *ngIf="node.name=='Sales Fees'|| node.name=='Sales COGS'">
             ( {{node.revenusData | number: '1.0-0'}}% of revenue)</span>
          <span class="value ms-auto">{{ node.type == "currency" ? "$" + node.value.toLocaleString("en") : node.type == "percentage" ? node.value.toLocaleString("en")
            + "%" : node.value.toLocaleString("en") }}</span>
        </div>
      </div>
      <div class="mat-tree-child" [class.mat-tree-invisible]="!treeControl.isExpanded(node)" role="group">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
</mat-dialog-content>
